import { MasterDocument } from '@util/firestore/master';
import { ListingDisplay } from '@c/MasterProductsPageV2';
import DemandBadge from './DemandBadge';
import NotifyMeModule from './NotifyMeModule';
import SellYoursModule from './SellYoursModule';
import SimilarListingsModule from './SimilarListingsModule';

interface EmptyStateContainerProps {
  master: MasterDocument;
  sellUrl: string;
  similarListings: ListingDisplay[];
}

export default function EmptyStateContainer({
  master,
  sellUrl,
  similarListings,
}: EmptyStateContainerProps) {
  return (
    <section id="listings" aria-label="No listings available">
      <div className="max-w-default mx-auto px-[2rem] md:px-[4rem] xl:px-default-padding-x py-[3rem]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[3rem]">
          <NotifyMeModule master={master} />
          <div className="flex flex-col gap-[1.2rem]">
            <DemandBadge masterId={master.id} />
            <SellYoursModule sellUrl={sellUrl} brand={master.brand} model={master.model} />
          </div>
        </div>
      </div>
      <SimilarListingsModule listings={similarListings} brand={master.brand} />
    </section>
  );
}
